import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './MyAdvisor.module.scss';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const MyAdvisor = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const [showDetails, setShowDetails] = useState(false);
  return (
      <div
          data-type="Promotion"
          data-creative-slot="Portal-Home-Top"
          data-promotion-name="My advisor"
          className={styles.Myadvisore_card}>
      {Model?.ShowAdvisorDetails &&
      (
        <>
      <h2 className={styles.Myadvisore_card_heading}>{PageData?.MyAdvisorHeading}</h2>
      <span className={styles.Myadvisore_card_subheading}>
        {Model?.AdvisorName}
      </span>
      <div className={styles.mainsection}>
        {Model?.AdvisorPhoneNumber && 
        (<div className={styles.Myadvisore_card_wrapper}>
          <div className={styles.Myadvisore_card_container}>
            <div className={styles.Myadvisore_card_icon}>
              <img
                src={process.env.PUBLIC_URL + '/images/icons/phone-icon.png'}
                alt="phone icon"
              />
            </div>

            <div className={styles.Myadvisore_card_text}>
              <h3 className={styles.Myadvisore_cardtext_heading}>
                {PageData?.CallNowHeadingText}
              </h3>
              <label className={styles.Myadvisore_cardtext_label}>
                {Model?.AdvisorPhoneNumber}
              </label>
            </div>
          </div>
          <a href={"tel:" + Model?.AdvisorPhoneNumber}>
            <img
              src={process.env.PUBLIC_URL + '/images/icons/Chevron-left.png'}
              alt="email icon"
            />
          </a>
        </div>)
        }
        {Model?.AdvisorEmail && 
        (<div className={styles.Myadvisore_card_wrapper}>
          <div className={styles.Myadvisore_card_container}>
            <div className={styles.Myadvisore_card_icon}>
              <img
                src={process.env.PUBLIC_URL + '/images/icons/Email-icon.png'}
                alt=""
              />
            </div>

            <div className={styles.Myadvisore_card_text}>
              <h3 className={styles.Myadvisore_cardtext_heading}>{PageData?.EmailNowHeadingText}</h3>
              <label className={styles.Myadvisore_cardtext_label}>
                {Model?.AdvisorEmail}
              </label>
            </div>
          </div>
          <a href={"mailto:" + Model?.AdvisorEmail}>
            <img
              src={process.env.PUBLIC_URL + '/images/icons/Chevron-left.png'}
              alt=""
            />
          </a>
        </div>)
        }

        <p className={styles.Myadvisore_card_linktext}>
          {PageData?.CannotReachAdvisorText}{' '}
          <a
            href="javasccript:void(0)"
            className={classnames(showDetails && styles.expanded)}
            onClick={() => setShowDetails(!showDetails)}
          >
            {PageData?.AdvisorClickHereText}
          </a>
        </p>
      </div>
      </>)}
      {(showDetails || !Model?.ShowAdvisorDetails)  && (
        <div className={styles.reachout_section}>
          <p>
          {PageData?.CannotReachAdvisorDescriptionText}
          </p>
          <a href={"mailto:" + PageData?.CustomerSupportEmail}>{PageData?.CustomerSupportEmail}</a>
        </div>
      )}
    </div>
  );
};

export default MyAdvisor;
